import Main from '../../pages/Main.vue';
import PageName from '../../constant/PageName';
import PermissionIds from '../../constant/PermissionIds';
// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [

  {
    path: '/tradeManage',
    icon: 'md-list',
    name: 'tradeManage',
    title: '账户管理',
    component: Main,
    children: [

      /** 交易流水部分 **/
      {
        path: 'tradeFlow',
        title: '交易流水',
        name: PageName.PAGE_TRADEMANAGE_TRADEFLOW,
        permissionId:PermissionIds.PERMISSION_TRADEMANAGE_TRADEFLOW,
        component: function (resolve) { require(['../../pages/tradeManage/tradeFlow/TradeFlow.vue'], resolve) },
      },
      /** 账户流水部分 **/
      {
        path: 'accountFlow',
        title: '账户流水',
        name: PageName.PAGE_TRADEMANAGE_ACCOUNTFLOW,
        permissionId:PermissionIds.PERMISSION_TRADEMANAGE_ACCOUNTFLOW,
        component: function (resolve) { require(['../../pages/tradeManage/accountFlow/AccountFlow.vue'], resolve) },
      },
      /** 账户信息部分 **/
      {
        path: 'accountInfo',
        title: '账户信息',
        name: PageName.PAGE_TRADEMANAGE_ACCOUNTINFO,
        permissionId:PermissionIds.PERMISSION_TRADEMANAGE_ACCOUNTINFO,
        component: function (resolve) { require(['../../pages/tradeManage/accountInfo/AccountInfo.vue'], resolve) },
      },
      
      /** 用户积分余额汇总部分 **/
      {
        path: 'integralTotal',
        title: '用户积分余额汇总',
        name: PageName.PAGE_TRADEMANAGE_INTEGRALTOTAL,
        permissionId:PermissionIds.PERMISSION_TRADEMANAGE_INTEGRALTOTAL,
        component: function (resolve) { require(['../../pages/tradeManage/integralTotal/IntegralTotal.vue'], resolve) },
      },
      /** 商户积分补偿部分 **/
      {
        path: 'compensate',
        title: '商户积分补偿',
        name: PageName.PAGE_TRADEMANAGE_COMPENSATE,
        permissionId: PermissionIds.PERMISSION_TRADEMANAGE_COMPENSATE,
        component: function (resolve) { require(['../../pages/tradeManage/compensate/Compensate.vue'], resolve) },
      },
      
    ]
  },


];

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  title: '首页',
  redirect: '/home',
  component: Main,
  children: [
    // { path: '/system/banner/add', title: '新增轮播图', name: PageName.PAGE_SYSTEM_BANNER_ADD, component: function(resolve) { require(['../../pages/system/banner/banner_add.vue'], resolve)} },
    // { path: '/system/banner/update', title: '修改轮播图', name: PageName.PAGE_SYSTEM_BANNER_UPDATE, component: function(resolve) { require(['../../pages/system/banner/banner_update.vue'], resolve)} },
    /** 积分兑换--订单明细 **/
    {
      path: 'IntegralExchangeVillage',
      title: '镇级统计',
      name: PageName.PAGE_TRADEMANAGE_INTEGRALEXCHANGE_VILLAGE,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function (resolve) { require(['../../pages/tradeManage/integralExchange/IntegralExchangeVillage.vue'], resolve) },
    },
    {
      path: 'InExchange',
      title: '兑换中订单',
      name: PageName.PAGE_TRADEMANAGE_INTEGRALEXCHANGE_IN,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function (resolve) { require(['../../pages/tradeManage/integralExchange/InExchange.vue'], resolve) },
    },

    {
      path: 'ExchangeDetail',
      title: '订单明细',
      name: PageName.PAGE_TRADEMANAGE_EXCHANGEDETAIL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function (resolve) { require(['../../pages/tradeManage/integralExchange/ExchangeDetail.vue'], resolve) },
    },
    {
      path: 'CompensateDetail',
      title: '商户积分补偿详情',
      name: PageName.PAGE_TRADEMANAGE_COMPENSATE_DETAIL,
      component: function (resolve) { require(['../../pages/tradeManage/compensate/CompensateDetail.vue'], resolve) },
    },
  ]
};



// WEBPACK FOOTER //
// ./src/router/routers/C_TradeManageRouter.js